var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking-row-header",class:{'global': _vm.global}},[(_vm.is_tracking)?[(!_vm.global)?_c('span',[_vm._v("Asset")]):_vm._e(),_c('span',[_vm._v("Event")]),_c('span',[_vm._v("Tracker")])]:(_vm.is_cta)?[(!_vm.global)?_c('span',[_vm._v("Asset")]):_vm._e(),_c('span',[_vm._v("Type")]),_c('span',[_vm._v("Output")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }